import { useEffect, useState } from 'react';
import { exercisesStats } from '../../../reducers/exercises-reducer';

const useTransCriptText = ({ voiceArray, dispatch }) => {
  const [currentVoiceIndex, setCurrentVoiceIndex] = useState(-1);
  useEffect(() => {
    // Exit early if conditions aren't met
    if (!voiceArray || voiceArray?.length === 0 || currentVoiceIndex < 0) {
      return;
    }

    // Check if currentVoiceIndex is within the bounds of voiceArray.audio_content
    if (currentVoiceIndex >= voiceArray?.length) {
      return;
    }

    // Set up timeout to update the index
    const timeoutDuration = voiceArray[currentVoiceIndex]?.duration || 0;
    const timeout = setTimeout(() => {
      setCurrentVoiceIndex(prevIndex => prevIndex + 1);
    }, timeoutDuration);

    // Cleanup timeout on component unmount or before setting a new timeout
    return () => {
      clearTimeout(timeout);
    };
  }, [currentVoiceIndex, voiceArray]); // Add voiceArray to dependencies

  useEffect(() => {
    if (currentVoiceIndex >= 0 && voiceArray) {
      dispatch({
        type: exercisesStats.transcription,
        payload: voiceArray[currentVoiceIndex]?.segment,
      });
    }
  }, [currentVoiceIndex, voiceArray]);

  return { currentVoiceIndex, setCurrentVoiceIndex };
};

export default useTransCriptText;
